import React from 'react';
import { motion } from 'framer-motion';
import { CaseStudy } from '../types';
import { ArrowRight } from 'lucide-react';
interface CaseStudyCardProps {
  study: CaseStudy;
  index: number;
  onSelect: (study: CaseStudy) => void;
}
const idToSlug: Record<string, string> = {
  'decision-intelligence': 'genentech',
  'walmart-marketplace': 'walmart',
  'amazon-recommendations': 'amazon',
  'enfusion-risk': 'enfusion'
};
export function CaseStudyCard({
  study,
  index
}: CaseStudyCardProps) {
  const slug = idToSlug[study.id] || study.id;
  const href = `#/case-study/${slug}`;
  return <motion.a href={href} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} className="block glass-card rounded-2xl p-8 md:p-12 group cursor-pointer hover:border-gold/30 transition-colors" data-id="element-40">
      <div className="flex flex-col md:flex-row gap-8 md:gap-16" data-id="element-41">
        <div className="md:w-1/3 flex flex-col justify-between" data-id="element-42">
          <div data-id="element-43">
            <div className="text-sm font-medium text-primary mb-1" data-id="element-44">
              {study.company}
            </div>
            <div className="text-xs text-secondary mb-6" data-id="element-45">{study.timeframe}</div>
            <div className="text-sm text-secondary font-medium mb-8" data-id="element-46">
              {study.role}
            </div>
          </div>

          <div data-id="element-47">
            <div className="text-3xl md:text-4xl font-bold text-gold tabular-nums tracking-tight mb-2" data-id="element-48">
              {study.heroMetric}
            </div>
            <div className="text-sm text-secondary leading-snug" data-id="element-49">
              {study.heroMetricContext}
            </div>
          </div>
        </div>

        <div className="md:w-2/3 flex flex-col justify-between" data-id="element-50">
          <div className="mb-8" data-id="element-51">
            <h3 className="text-2xl md:text-3xl font-bold text-primary tracking-tight mb-6" data-id="element-52">
              {study.title}
            </h3>
            <p className="text-secondary text-lg leading-relaxed" data-id="element-53">
              {study.summary}
            </p>
          </div>

          <div className="flex items-center text-gold text-sm font-medium" data-id="element-54">
            Read case study
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-55" />
          </div>
        </div>
      </div>
    </motion.a>;
}